import React from "react";

const About = () => {
  const isDarkMode = document.body.classList.contains("dark");

  return (
    <div
      className={`min-h-screen flex flex-col justify-start items-center p-8 ${
        isDarkMode ? "bg-[#111827] text-white" : "bg-white text-gray-900"
      }`}
      style={{ overflow: "hidden" }}
    >
      {/* Heading */}
      <h1 className="text-5xl font-bold mb-8 text-center">About Me</h1>

      {/* Content */}
      <div className="flex flex-wrap justify-between w-full max-w-6xl px-4 mb-12">
        {/* Left Content */}
        <div className="flex-1 pr-5 text-justify">
          <p className="mb-4 leading-relaxed text-lg">
            I am a passionate Front-End Developer with solid experience in building modern,
            responsive, and user-focused web interfaces. I have worked extensively with HTML, CSS, JavaScript, Typescript , React, and Next.js
            delivering real-world projects that emphasize performance, clean code, and excellent user experience.
          </p>
          <p className="mb-4 leading-relaxed text-lg">
            Throughout my journey, I focused not only on learning tools, but on truly understanding how and why they are used.
            This approach helped me solve practical problems, write scalable and maintainable code, and transform designs into functional,
            high-quality interfaces.
          </p>
          <p className="mb-4 leading-relaxed text-lg">
            I have built and contributed to multiple projects, including :
            <li style={{marginLeft:"100px"}}>Professional landing pages</li>
            <li style={{marginLeft:"100px"}}>Component-based React applications</li>
            <li style={{marginLeft:"100px"}}>Projects that consume APIs and handle dynamic data</li>
            
          </p>
          <p className="mb-4 leading-relaxed text-lg">
            Currently, I am deepening my knowledge of the React ecosystem and actively transitioning toward becoming a MERN Stack Developer,
            with the goal of building complete, end-to-end web applications.
          </p>
        </div>

        {/* Right Content (Avatar or Image) */}
        <div className="flex-1 flex justify-center items-center mt-5">
          <div className="bg-gray-200 rounded-xl w-72 h-96 flex flex-col items-center justify-end overflow-hidden relative">
            {/* User Image */}
            <img
              src="/images/myphoto.png" // Update this with the path to your image
              alt="My Avatar"
              className="w-full h-full object-cover absolute top-0 left-0 z-10"
            />
            {/* Name Section */}
            <div className="w-full bg-black bg-opacity-60 text-white text-center py-2 font-bold z-20">
              Mohamed Shaheen
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
